// Telemetry only. This module never stores responses or combines/replays requests.
export const categories = ['auth_me','auth_entitlement_sales','auth_entitlement_video','service_check','node_register','claim','queue_control','task_read','agent_preview','agent_confirm','feedback','other'] as const;
type Category = typeof categories[number];
const codes = ['ok','other','SIGNED_OUT','SESSION_REPLACED','SESSION_REVOKED','SESSION_EXPIRED','AUTH_UNAVAILABLE','APP_NOT_GRANTED','APP_DISABLED','APP_NOT_FOUND','NODE_OBSERVATION_STALE','TASK_NOT_FOUND','TASK_EXPIRED','QUEUE_REVISION_CONFLICT'];
type Row = {category:Category;method:string;status:number|null;code:string;error_class:string;duration_ms:number;at:number};
let rows:Row[]=[];
let lost=false;
export function clearRequestDiagnostics(){rows=[];lost=false;}
export function requestCategory(path:string):Category {
  const value=path.split('?')[0];
  if(value==='/session'||value==='/me')return 'auth_me';
  if(value.includes('video-workshop'))return 'auth_entitlement_video';
  if(value.includes('queue-control'))return 'queue_control';
  if(value.includes('agent-runs'))return value.endsWith('/confirm')?'agent_confirm':'agent_preview';
  if(value.includes('feedback'))return 'feedback';
  if(value.includes('/tasks')||value.includes('device-queues'))return 'task_read';
  return 'other';
}
export function rememberRequest(path:string,method:string,status:number|null,code:string,errorClass:string,duration:number){
  const at=Math.floor(Date.now()/1000);
  rows=rows.filter(row=>at-row.at<=86400&&row.at<=at);
  if(rows.length>=10000){rows.shift();lost=true;}
  rows.push({category:requestCategory(path),method:['GET','HEAD','POST','PUT','PATCH','DELETE'].includes(method)?method:'OTHER',
    status:status!==null&&Number.isInteger(status)&&status>=100&&status<=599?status:null,
    code:codes.includes(code)?code:'other',error_class:['none','transport','http_status','json_parse','envelope','other'].includes(errorClass)?errorClass:'other',
    duration_ms:Math.min(600000,Math.max(0,Math.round(duration))),at});
}
export function requestSnapshot(){
  const now=Math.floor(Date.now()/1000);
  const current=rows.filter(row=>row.at>=now-86400&&row.at<=now);
  const failures=current.filter(row=>row.error_class!=='none');
  const counts=categories.flatMap(category=>{
    const items=current.filter(row=>row.category===category&&row.at>=now-3600);
    return items.length?[{category,count:items.length,failed:items.filter(row=>row.error_class!=='none').length,
      under_100ms:items.filter(row=>row.duration_ms<100).length,under_1s:items.filter(row=>row.duration_ms>=100&&row.duration_ms<1000).length,
      under_8s:items.filter(row=>row.duration_ms>=1000&&row.duration_ms<8000).length,over_8s:items.filter(row=>row.duration_ms>=8000).length}]:[];
  });
  return {recent:failures.slice(-20),counts,truncated:lost||failures.length>20};
}
